import React from 'react';
import useConsentCheck from 'hooks/use-consent-check';
import useClient from 'hooks/use-client';
import ErrorCookiesSettings from '../error-cookies-settings/error-cookies-settings';
import Delay from '../delay/delay';

const StoreLocator = ({ consentCode, errorText }) => {
  const isConsentGranted = useConsentCheck(consentCode);
  const isClient = useClient();

  return (
    <div>
      {isClient && !isConsentGranted && (
        <Delay waitTime={500}>
          <ErrorCookiesSettings errorText={errorText} />
        </Delay>
      )}
      {isConsentGranted && <div className="storerocket-store-locator"></div>}
    </div>
  );
};

export default StoreLocator;
